import { useCreate } from '@refinedev/core';

export type GenerateSuitabilityReportPayload = {
  reportTemplate?: string;
  supportingDataUploadFileIds?: string[];
  appendixFileIds?: number[];
  temporaryAppendixFileIds?: number[];
  lastReviewDate?: string;
  addTitlePage?: boolean;
  addTableOfContents?: boolean;
  useDeepThinking?: boolean;
};

export function useGenerateSuitabilityReport() {
  const { mutateAsync, error, isLoading, reset } = useCreate<GenerateSuitabilityReportPayload>();

  const generateSuitabilityReport = async (
    clientId: string,
    values: GenerateSuitabilityReportPayload,
  ) => {
    return mutateAsync({
      resource: `clients/${clientId}/suitability-reports`,
      values,
    });
  };

  return {
    generateSuitabilityReport,
    error,
    isLoading,
    reset,
  };
}
